import * as React from 'react';

import * as styles from './styles.css';
import { TVerticalSliderProps, VerticalSlider } from './VerticalSlider';

type TVerticalSliderFullscreenProps = Omit<TVerticalSliderProps, 'arrowOffset' | 'containerClass'>;

export function VerticalSliderFullscreen(props: TVerticalSliderFullscreenProps) {
  return <VerticalSlider {...props} containerClass={styles['container--fullscreen']} arrowOffset={26} />;
}
